import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import PropTypes from 'prop-types';

import { cn } from '../../libraries/tailwind/utils';
import useColorsStore from '@/app/store/colors';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className, ...props }, ref) => {

  const { dynamicBackgroundColor, dynamicTextColor } = useColorsStore();
  return (
    <TabsPrimitive.List
      ref={ref}

      style={{ backgroundColor: dynamicBackgroundColor, color: dynamicTextColor }}
      className={cn(
        'inline-flex h-10 items-center shadow-md justify-center rounded-md text-muted-foreground',
        className
      )}
      {...props} />
  );
});
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(({ className, tab, activeTab, permissions, ...props }, ref) => {

  const { isLight } = useColorsStore();

  if (tab?.hasPermissions && !tab.hasPermissions(permissions)) {
    return null;
  }

  const style = isLight
    ? { backgroundColor: 'black', color: 'white', opacity: 0.6 }
    : { backgroundColor: 'white', color: 'black', opacity: 0.6 };

  return (
    <TabsPrimitive.Trigger
      ref={ref}
      style={activeTab === tab.name && style}
      className={cn(
        // eslint-disable-next-line max-len
        'inline-flex mx-1 items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm',
        className
      )}
      value={tab ? tab.name : undefined}
      {...props} />
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, tab, permissions, ...props }, ref) => {
  if (tab?.hasPermissions && !tab.hasPermissions(permissions)) {
    return null;
  }

  return (
    <TabsPrimitive.Content
      ref={ref}
      className={cn(
        'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        className
      )}
      value={tab ? tab.name : undefined}
      {...props} />
  );
});
TabsContent.displayName = TabsPrimitive.Content.displayName;

TabsList.propTypes = {
  className: PropTypes.string
};

TabsTrigger.propTypes = {
  className: PropTypes.string,
  tab: PropTypes.object,
  activeTab: PropTypes.string,
  permissions: PropTypes.array
};

TabsContent.propTypes = {
  className: PropTypes.string,
  tab: PropTypes.object,
  permissions: PropTypes.array
};

export { Tabs, TabsList, TabsTrigger, TabsContent };
